export default __webpack_public_path__ + "static/media/LogoLogin.fa6e6669.svg";